import { Component } from '@angular/core';

/**
 * Skeleton component for product card
 * @export
 * @class AtmSkeletonProductCardComponent
 */
@Component({
  selector: 'atm-skeleton-product-card',
  templateUrl: './atm-skeleton-product-card.component.html',
  styleUrls: ['./atm-skeleton-product-card.component.scss']
})
export class AtmSkeletonProductCardComponent {

}
